const decode = require('jwt-decode');

export default {
    user() {
        const token = localStorage.getItem('token') || null;
        let user = {};

        if (token) {
            user = decode(token);
            return user;
        }
        return null;
    },
    cart(state) {
        return state.cart || []
    },
}